// src/stores/useMapActions.js
import { create } from "zustand";

export const useMapActions = create((set) => ({
  zoomToBounds: null,

  setZoomHandler: (fn) => {
    set({ zoomToBounds: fn });
  },
}));